import "./App.css";

function App() {
	return (
		<div id="main">
			<div id="text">Philipps Traumfrau:</div>
			<center>
				<img src="/FE.jpeg" alt="Traumfrau" id="image" />
			</center>
		</div>
	);
}

export default App;
